/**
 * Known third-party script domains that emit noise errors.
 * Shared across Sentry beforeSend and unhandled rejection handlers
 * to ensure consistent filtering.
 */
export const THIRD_PARTY_DOMAINS = ['crisp.chat', 'cdn.', 'analytics', 'gtag', 'hotjar'] as const;

/**
 * Check if an error stack trace originates from a third-party script.
 */
export function isThirdPartyStack(stack: string): boolean {
  return THIRD_PARTY_DOMAINS.some((domain) => stack.includes(domain));
}
